export default function customValidate(val, allValues, props, name) {
	//console.log(arguments);
	switch (
		name //based on field NAME
	) {
		case 'email':
			return !validationStructures('email', val) && 'Enter a valid email address';
		case 'postcode':
			return !validationStructures('postcode', val) && 'Invalid UK Post Code';
		case 'postCode':
			return !validationStructures('postcode', val) && 'Invalid UK Post Code';
		case 'niNumber':
			return !validationStructures('niNumber', val) && 'NI Number invalid';
		case 'tel':
			return !validationStructures('telno', val) && 'Invalid phone number';
		case 'mobile':
			return !validationStructures('telno', val) && 'Invalid phone number';
		case 'fax':
			return !validationStructures('telno', val) && 'Invalid phone number';
		case 'utr':
			return !!val && !/^[0-9]{10}$/i.test(val) && 'UTR is 10 digits';
		case 'new_pin':
			return !validationStructures('pin', val) && 'PIN must be 4-6 digits';
		case 'current_pin':
			return !validationStructures('pin', val) && 'PIN must be 4-6 digits';
		case 'password':
			return !validationStructures('pass', val) && 'Password must be 6+ characters with uppercase letter, lowercase letter and number';
	}

	return false;
}

function validationStructures(type, val) {
	//returns true if passes validation!
	switch (type) {
		case 'email':
			return !val || /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val);
		case 'postcode':
			return !val || /^(GIR 0AA)|((([A-Z][0-9][0-9]?)|(([A-Z][A-HJ-Y][0-9][0-9]?)|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z])))) ?[0-9][A-Z]{2})$/i.test(val);
		case 'niNumber':
			return !val || /^([A-Z]{2}[0-9]{6}[A-Z]?)|([0-9]{2}[A-Z][0-9]{5})$/i.test(val);
		case 'telno':
			return !val || /^[\+0][0-9 ]{9,20}$/i.test(val);
		case 'pass':
			return !val || /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/i.test(val);
		case 'pin':
			return !val || /^[0-9]{4,6}$/.test(val);
	}
	return false;
}
